angular.module('navigationPaneModule')
  .directive('navigationPane', function() {
    return {
      restrict: 'E',
      templateUrl: '/resources/navigation-pane/partials/navigation-pane.html',
      controller: ['$scope', 'authentication', '$element', '$filter', '$timeout', '$state', 'navigationApi', 'navigation', 'narrativeFilter',
            function($scope, $authentication, $element, $filter, $timeout, $state, $navigationApi, $navigation, narrativeFilter) {

        $scope.filterQuery = {
            name: ''
        };
        $scope.flag = false;
        $scope.stateService = $state;

        // Calculate scrollable list height so it fills out bottom of nav
        function getListHeight() {
            var scrollableList = angular.element($element).find('#navigation-pane-scrollable-list');
            var verticalOffset = scrollableList.position().top;
            var navHeight = angular.element($element).find('nav').outerHeight();
            var listHeight = Math.max(0, navHeight - verticalOffset);
            return listHeight;
        }

        $scope.getListStyle = function () {
            var height = getListHeight() + 'px';

            return {
                'height': height
            };
        };

        $scope.getNarratives = function(item) {
            var narratives = '';
            _.each(item.status_reason_codes, function(code) {
                var narrative = '<p>' + narrativeFilter(code, item.type, item.first_name) + '</p>';
                narratives = narratives.concat(narrative);
            });

            return narratives;
        };

        $scope.getInfoRole = function(customer) {
          return customer.role;
        };

        // Check if an item in the top list is active so it can be highlighted
        $scope.isTopListItemActive = function (listItem) {
            if (!listItem.name) {
                return false;
            }

            if($scope.item) {
              // If list item matches the current item in the right pane highlight it.
              // This currently can happen for classroom or teacher level.
              if (listItem.type === $scope.item.type && listItem.id === $scope.item.id) {
                  return true;
              }

              // If right pane item is student
              if ($scope.item.type === 'student') {
                  if (listItem.type === 'teacher' && listItem.id === parseInt($state.params.teacherId) && $state.params.classroomId === undefined) {
                      // highlight teacher of the student if classroom not selected
                      return true;
                  } else if (listItem.type === 'classroom' && listItem.id === parseInt($state.params.classroomId)) {
                      // highlight the classroom for the student
                      return true;
                  }
              }
            }
        };

        /* selectItem
         * Triggered by clicking on any item in the navigation pane.
         */
        $scope.selectItem = function(item) {
          $navigation.tryNavigate().then(
            function() {
              $scope.flag = true;
              $scope.$emit('route', item);
              $timeout(function() {
                $scope.flag = false;
              }, 750);
            }
          );
        };

        $scope.setSectionTitle = function(type, isTeacher) {
          switch (type) {
            case 'district':
              $scope.sectionTitle = 'Schools';
              break;
            case 'grade':
              $scope.sectionTitle = ($state.params.schoolId) ? 'Teachers': 'Schools';
              break;
            case 'school':
              $scope.sectionTitle = 'Teachers';
              break;
            case 'teacher':
              $scope.sectionTitlePrimary = isTeacher ? 'My Classrooms' : 'Classrooms';
              $scope.sectionTitle = 'Students';
              break;
            case 'guardian':
              $scope.sectionTitle = 'Students';
              break;
            case 'classroom':
            case 'student':
              $scope.sectionTitlePrimary = isTeacher ? 'My Classrooms' : 'Classrooms';
              $scope.sectionTitle = 'Students';
              break;
            default:
              $scope.sectionTitle = 'Students';
              break;
          }
        };

        // watch for change from master.js
        $scope.$watch('itemList', function (itemList) {
          if (itemList) {
            var customer = $authentication.getCustomer();

            $scope.customerIsAdmin = $authentication.isAdmin(customer);
            $scope.customerIsTeacher = $authentication.isTeacher(customer);

            $scope.filteredList = itemList;
            $scope.filterQuery.name = '';
            $scope.infoRole = $scope.getInfoRole(customer);
          }
        });

        $scope.$watch('filteredList', function (newVal) {
          if (newVal) {
            // Subtract one from item count when current item is teacher
            // because we don't want to count the all teacher's classrooms item.
            $scope.itemCount = $scope.filteredList.length;
          }
        });

        // watch for change from master.js
        $scope.$watch('breadcrumbType', function (breadcrumbType) {
          if (breadcrumbType) {
            var customer = $authentication.getCustomer();
            var isTeacher = $authentication.isTeacher(customer);

            $scope.setSectionTitle(breadcrumbType, isTeacher);
          }
        });

        $scope.$watch('filterQuery.name', function (newVal) {
            if (!newVal) {
                $scope.filteredList = $scope.itemList;
            } else {
                $scope.filteredList = $filter('filter')($scope.itemList, $scope.filterQuery);
            }
        });

      }]
    };
  });
